<template>
  <div id="periodical" class="docker__item">
      <van-cell title="往期" @click="showPopup">
        <van-icon name="calendar-o" size=".6rem" />
        <span class="docker__item__text">往期</span>
      </van-cell>
      <!-- <van-cell is-link @click="showPopup">
        <van-icon name="calendar-o" size=".6rem" />
        <span class="docker__item__text">目录</span>
      </van-cell> -->
      <van-popup
        v-model:show="show"
        id="docker__item__calender"
        position="bottom"
        :style="{height:'11rem',width: '100% '}"
      >
        <div>
          <van-dropdown-menu>
            <van-dropdown-item :titleDate="titleDate" v-model="value" :options="options" @change="handleSelectDate"/>
          </van-dropdown-menu>
          <div class="grid">
            <van-grid :column-num="6" v-if="oneYearDateList">
              <van-grid-item
                v-for="(item, index) in oneYearDateList"
                :key="index"
                @click="getPageDate(item, index)"
                :text="index<9?'0'+(index+1):index+1"
                :class="activeIndex===index?'activeSelect': ''"
              >
              </van-grid-item>
            </van-grid>
          </div>
        </div>
      </van-popup>
    </div>
</template>

<script>
import { ref } from 'vue'
import { get } from '../../utils/request'
import { useStore } from 'vuex'
export default {
  name: 'PeriodicalDate',
  props: {
    newspaperId: String
  },
  setup (props, { emit }) {
    const show = ref(false)
    const value = ref(0)
    const options = []
    const showPopup = () => {
      show.value = true
    }
    const titleDate = ref('')
    const activeIndex = ref('')
    const dateList = ref([])
    const allDateList = ref([])
    const allPageDateList = ref([])
    const oneYearDateList = ref([])
    const store = useStore()
    const getDateList = async () => {
      const url = `pageDateController/getPageDateList?newspaperId=${props.newspaperId}`
      const result = await get(url)
      for (let i = 0; i < result.list.length; i++) {
        const dateItem = result.list[i].pageDate
        allDateList.value.push(dateItem)
        if (dateList.value.indexOf(dateItem.substr(0, 4)) === -1) {
          dateList.value.push(dateItem.substr(0, 4))
        }
        const first = dateList.value[0]
        if (dateItem.indexOf(first) !== -1) {
          titleDate.value = dateItem.substr(0, 4)
          oneYearDateList.value.push(dateItem)
          oneYearDateList.value.sort()
        }
        const length = oneYearDateList.value.length
        const lastDate = oneYearDateList.value[length - 1]
        getPageDate(lastDate, length - 1)
      }
      for (let i = 0; i < dateList.value.length; i++) {
        const index = i
        const yearItem = dateList.value[i]
        const optionList = {
          text: yearItem,
          value: index
        }
        options.push(optionList)
        for (let i = 0; i < allDateList.value.length; i++) {
          if (allDateList.value[i].indexOf(yearItem) !== -1) {
            allPageDateList.value.push({
              date: allDateList.value[i],
              index: index
            })
          }
        }
      }
    }
    const handleSelectDate = (value) => {
      activeIndex.value = ''
      oneYearDateList.value = []
      for (let i = 0; i < allPageDateList.value.length; i++) {
        const index = allPageDateList.value[i].index
        if (index === value) {
          oneYearDateList.value.push(allPageDateList.value[i].date)
          oneYearDateList.value.sort()
        }
      }
      titleDate.value = oneYearDateList.value[0].substr(0, 4)
    }
    const getPageDate = (date, index) => {
      show.value = false
      activeIndex.value = index
      store.dispatch('getPageDate', date)
      emit('emit-per', date)
    }

    getDateList()
    return {
      titleDate,
      value,
      options,
      oneYearDateList,
      activeIndex,
      showPopup,
      handleSelectDate,
      getPageDate,
      show
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../style/variables.scss';
.docker__item {
    flex: 1;
    text-align: center;
    color: $content-fontcolor;
    &__text{
      font-size: .45rem;
      margin-bottom: 1rem;
    }
    .grid{
      .activeSelect{
        background-color: #f2f3f5;
        color: #ffffff;
      }
    }
  }
  :root{
    --van-grid-item-content-background-color: #DE1B23;
    --van-grid-item-text-color: #ffffff;
}
</style>
